import PropTypes from 'prop-types';
import React from 'react';
import { graphql, useFragment } from 'react-relay';

import Loading from 'src/components/Loading';
import TimeOfUsable from 'src/components/TradeRule/TimeOfUse/TimeOfUsable';

const TradeRuleListTableItemClauseFragment = graphql`
  fragment TradeRuleListTableItemClause_clause on Clause {
    uuid
    price
    timezone
    ignorePublicHolidays
    ignoreDaylightSavings
    publicHolidayRegion
    monthsOfYear
    daysOfWeek
    timesOfDay {
      start {
        hours
        minutes
        seconds
      }
      finish {
        hours
        minutes
        seconds
      }
    }
  }
`;

/**
 * TradeRuleListTableItemClause component displays clause information for trade rules.
 * @param {object} props - Component props
 * @param {object} props.clause - The clause data from GraphQL
 * @param {boolean} props.showConditions - Whether to show conditions in the clause display
 * @returns {React.ReactElement} - TradeRuleListTableItemClause component
 */
function TradeRuleListTableItemClause({ clause: clauseData, showConditions = true }) {
  if (!clauseData) {
    return <Loading />;
  }

  const clause = useFragment(TradeRuleListTableItemClauseFragment, clauseData);

  return <TimeOfUsable timeOfUsable={clause} showConditions={showConditions} />;
}

TradeRuleListTableItemClause.propTypes = {
  clause: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  showConditions: PropTypes.bool,
};

export default TradeRuleListTableItemClause;
